import React from "react";
import { NavLink } from "react-router-dom"; 
import styled from "styled-components";

const Head = styled.div`
    background: ${({content}) => content.titleBgColor};
    color: ${({content}) => content.titleTextColor};
`;

const HeadNav = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
`;

const Headline = styled.div`
    display: flex;
    flex-wrap: nowrap;
    margin-left: 10px;
    padding: 5px;
    justify-content: 'space-between';
    font-size: ${({content}) => content};
`;

export default function Header({content, smallWindow}) {

    const imgSrc = (content.headerImg && content.headerImg.length>0) ? content.imageMap[content.headerImg] : '/static_content/upload_image.jpg';

    return(
        <Head content={content.styles}>
            <HeadNav>
                {!smallWindow ? <Headline content={'1rem'}>{content.headline}</Headline> : null}
                <NavLink to="/">
                    <img src={imgSrc} alt={content.businessName} style={{'width': '100%'}}/>
                </NavLink>
                {smallWindow ? <Headline content={'0.75rem'}>{content.headline}</Headline> : null}
                
            </HeadNav>
            
            <div style={{ padding: '5px', background: content.styles.titleBgColor}}><hr color={content.styles.highlightColor}></hr></div>
        </Head>
    )
}